import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionActions from '@material-ui/core/AccordionActions';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import GaugeChart from 'react-gauge-chart';

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: "#ccc",
    },
    buttons: {
        display: 'flex',
        justifyContent: 'flex-end',
    },
    button: {
        marginTop: theme.spacing(3),
        marginLeft: theme.spacing(1),
    },
    card: {
        backgroundColor: "transparent",
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        fontWeight: theme.typography.fontWeightMedium,

    },
    accordion: {
        width: '100%',
        backgroundColor: "transparent",
    },
    media: {
        height: 140,
    },
    cardfont: {
        color: 'black'
    }
}));

const AccordLayer = ({ layer, layerThreat, layerThreatLevel, content, url }) => {

    const classes = useStyles();

    return (
        <Grid container spacing={3}>
            <Grid item xs={12} md={12}>
                <Accordion className={classes.accordion} defaultExpanded={true}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon color="primary" />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                    >
                        <Typography variant="h6" className={classes.heading}>{(layer === 'client' ? 'Client' : layer === 'api' ? 'API' : 'Cloud')} Layer Details</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Grid container spacing={3}>
                            <Grid item xs={12} md={3}>
                                <GaugeChart id="gauge-chart"
                                    nrOfLevels={10}
                                    arcsLength={[0.1, 0.1, 0.2, 0.2, 0.4]}
                                    colors={['#5BE12C', '#F5CD19', '#EA4228']}
                                    percent={layerThreat}
                                    hideText={true}
                                    needleColor="#fff"
                                />
                                <Typography align="center">{layerThreatLevel}</Typography>
                            </Grid>
                            <Grid item xs={12} md={9}>
                                <Typography align="left">
                                    {content}
                                </Typography>
                            </Grid>
                        </Grid>
                    </AccordionDetails>
                    <AccordionActions>
                        <Button href={url} size="small" target="_blank">Learn More</Button>
                    </AccordionActions>
                </Accordion>
            </Grid>
        </Grid>
    );
}

export default AccordLayer;